import { jwtDecode } from 'jwt-decode';
import { TSP } from '../../models';

export const TOKEN_STORAGE_KEY = 'token';

export const getStoredToken = (): string | null => localStorage.getItem(TOKEN_STORAGE_KEY);

export const setStoredToken = (token: string): void => localStorage.setItem(TOKEN_STORAGE_KEY, token);

export const clearStoredToken = (): void => localStorage.removeItem(TOKEN_STORAGE_KEY);

/**
 * Decodes a JWT without ever throwing. `jwtDecode` raises `InvalidTokenError` on anything that is not a
 * well-formed token, and `localStorage` is user-writable, so any garbage there is treated as "not authenticated".
 */
export const decodeToken = (token: string | null): TSP.API.Helpers.JwtTokenPayload | null => {
  if (!token) {
    return null;
  }

  try {
    return jwtDecode<TSP.API.Helpers.JwtTokenPayload>(token);
  } catch {
    return null;
  }
};

export const getStoredTokenPayload = (): TSP.API.Helpers.JwtTokenPayload | null => decodeToken(getStoredToken());

/** A payload without `exp` counts as expired — an unbounded token is never trusted. */
export const isTokenExpired = (payload: TSP.API.Helpers.JwtTokenPayload | null): boolean => {
  if (!payload?.exp) {
    return true;
  }

  return payload.exp <= Date.now() / 1000;
};
